/** True while a music video owns Media Session / background playback. */
let active = false;

export const VIDEO_SESSION_EVENT = 'np-video-session';
/** Catalog/radio audio is starting — tear down the music video session. */
export const AUDIO_TAKES_OVER_EVENT = 'np-audio-takes-over';

export function setVideoSessionActive(next: boolean) {
  if (active === next) return;
  active = next;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(VIDEO_SESSION_EVENT));
  }
}

export function isVideoSessionActive() {
  return active;
}

/** Call when on-demand/radio audio begins so video does not play underneath. */
export function audioTakesOverFromVideo() {
  if (!active) return;
  setVideoSessionActive(false);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(AUDIO_TAKES_OVER_EVENT));
  }
}
